import { render } from "./StaticMasonryLayout.vue?vue&type=template&id=c4a43cd0"
import script from "./StaticMasonryLayout.vue?vue&type=script&lang=ts"
export * from "./StaticMasonryLayout.vue?vue&type=script&lang=ts"

import "./static-masonry-layout.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script